export const formatTimestampToDate = (timestamp, formater) => {
  if (timestamp == null) return "";

  let date = new Date();
  date.setTime(parseInt(timestamp));
  formater = formater != null ? formater : "yyyy-MM-dd hh:mm";
  Date.prototype.Format = function (fmt) {
    const o = {
      "M+": this.getMonth() + 1,
      "d+": this.getDate(),
      "h+": this.getHours(),
      "m+": this.getMinutes(),
      "s+": this.getSeconds(),
      "q+": Math.floor((this.getMonth() + 3) / 3),
      S: this.getMilliseconds(),
    };

    if (/(y+)/.test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        (this.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    for (let k in o) {
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length == 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
    }
    return fmt;
  };
  return date.Format(formater);
};

export const formatNumberToCurrency = (number, places, symbol) => {
  if (number == null) return "";

  number = number || 0;
  places = !isNaN((places = Math.abs(places))) ? places : 2;
  symbol = symbol !== undefined ? symbol : "$";
  var negative = number < 0 ? "-" : "",
    i = parseInt((number = Math.abs(+number || 0).toFixed(places)), 10) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return symbol +
  negative +
  (j ? i.substr(0, j) + "," : "") +
  i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + ",") +
  (places
    ? "." +
      Math.abs(number - i)
        .toFixed(places)
        .slice(2)
    : "");
};

export const formatNumberToPercentage = (number, places) => {
  if (number == null) return "";

  number = number || 0;
  places = !isNaN((places = Math.abs(places))) ? places : 2;
  var negative = number < 0 ? "-" : "",
    i = parseInt((number = Math.abs(+number || 0).toFixed(places)), 10) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return negative +
  (j ? i.substr(0, j) + "," : "") +
  i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + ",") +
  (places
    ? "." +
      Math.abs(number - i)
        .toFixed(places)
        .slice(2)
    : "") +
  "%";
};

export const formatBEDateStringToFE = (date) => {
  // MM/dd/yyyy to yyyy-MM-dd
  const dateInfo = date.split("/");
  return dateInfo[2] + "-" + dateInfo[0] + "-" + dateInfo[1];
};

export const formatFEDateStringToBE = (date) => {
  // yyyy-MM-dd to MM/dd/yyyy
  const dateInfo = date.split("-");
  return dateInfo[1] + "/" + dateInfo[2] + "/" + dateInfo[0];
};